if (!customElements.get('featured-collection')) {
  customElements.define(
    'featured-collection',
    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback () {
        this.adjustSwiper()
        this.slideArrows.forEach(element => {
          element.addEventListener('click', this.onArrowClicked.bind(this))
        })
        this.onResize()
      }

      disconnectedCallback() {
        this.slideArrows.forEach(element => {
          element.removeEventListener('click', this.onArrowClicked.bind(this))
        })
      }

      onResize() {
        if (this.mainSlider.swiper?.isLocked) {
          this.classList.add('locked')
        } else {
          this.classList.remove('locked')
        }
      }

      onSlideChanged() {
        this.querySelectorAll('.js-slide-arrow').forEach(element => {
          element.removeAttribute('disabled')

          if (this.mainSlider.swiper.isEnd && element.getAttribute('data-direction') == 'next') {
            element.setAttribute('disabled', true)
          }

          if (this.mainSlider.swiper.isBeginning && element.getAttribute('data-direction') == 'prev') {
            element.setAttribute('disabled', true)
          }
        })
      }

      onArrowClicked(event) {
        const direction = event.currentTarget.getAttribute('data-direction') || 'prev'
        if (direction == 'prev') {
          this.mainSlider.swiper?.slidePrev()
        } else {
          this.mainSlider.swiper?.slideNext()
        }
      }

      adjustSwiper () {
        Object.assign(this.mainSlider, {
          breakpoints: {
            750: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            990: {
              slidesPerView: 4,
              spaceBetween: 40,
            }
          },
          on: {
            resize: () => {
              this.onResize()
            },
            transitionEnd: () => {
              this.onSlideChanged()
            }
          }
        });

        this.mainSlider.initialize();
      }

      get mainSlider() {
        return this.querySelector('.js-media-slider')
      }

      get slideArrows() {
        return this.querySelectorAll('.js-slide-arrow')
      }
    }
  );
}
